import { render } from "./InformationPopup.vue?vue&type=template&id=00213e64&ts=true"
import script from "./InformationPopup.vue?vue&type=script&lang=ts"
export * from "./InformationPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__